import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useCart } from "react-use-cart";
import Cart from "./Cart";
import { FormatRupiah } from "./services/FormatRupiah";

const MerchandiseHome = ({ produk }) => {
  const location = useLocation();
  const { addItem, totalUniqueItems, inCart, items, emptyCart } = useCart();
  const [showCart, setShowCart] = useState(false);

  let memberExist = false;
  for (let i = 0; i < items.length; i++) {
    if (items[i].is_with_member == "1") {
      memberExist = true;
      break;
    }
  }

  const handleAddToCart = (prod) => {
    addItem(prod);
  };

  return (
    <>
      <section className="merchandise-new-layout">
        {/* Hero Section */}
        <div className="merch-hero-banner">
          <div className="merch-hero-overlay"></div>
          <img src="/assets/merchandise/hero_banner.png" alt="Hero Banner" className="merch-hero-bg" />
          <div className="container merch-hero-content">
            <p className="merch-hero-subtitle">UPDATED EXCELLENCE</p>
            <h1 className="merch-hero-title">Official<br /> Merchandise</h1>
            <p className="merch-hero-text">
              Tunjukkan semangat studi luar negerimu. Merchandise eksklusif dari NIEC Indonesia. Mulai perjalanan globalmu dengan gaya.
            </p>
            <button className="btn btn-shop-now">SHOP NOW</button>
          </div>
        </div>

        <div className="container content-merchandise" style={{ paddingTop: '50px' }}>
          {/* Header */}
          {/* <div className="merch-special-edition-grid">
            <div className="merch-special-card">
              <div className="special-badge">LIMITED<br/>EDITION</div>
              <img src="/assets/merchandise/varcity_jacket.png" alt="NIEC VARCITY" />
              <div className="special-card-content">
                <p className="special-subtitle">SPECIAL EDITION</p>
                <h3 className="special-title">NIEC,<br/>VARCITY</h3>
                <p className="special-desc">SALE 20% EVERY MONDAY</p>
                <button className="btn btn-shop-now-small">SHOP NOW</button>
              </div>
            </div>
            <div className="merch-special-card">
              <img src="/assets/merchandise/backpack_ransel.png" alt="NIEC RANSEL" />
              <div className="special-card-content content-right">
                <p className="special-subtitle text-right">SPECIAL EDITION</p>
                <h3 className="special-title text-right">NIEC,<br/>RANSEL</h3>
                <button className="btn btn-shop-now-small float-right">SHOP NOW</button>
                <div className="clearfix"></div>
                <div className="special-price-box">
                  <p>Rp 200,000.00</p>
                  <button className="btn btn-cart-small"><i className="bi bi-bag-fill"></i> Keranjang</button>
                </div>
              </div>
            </div>
          </div> */}

          {/* Product Grid */}
          <div className="merch-grid-section">
            <div className="merch-section-header">
              <div className="merch-header-text">
                <h2>Koleksi <br />Merchandise NIEC</h2>
                <p>Bawa semangat meraih pendidikan global melalui koleksi merchandise eksklusif NIEC.</p>
              </div>
              <button onClick={() => setShowCart(true)} className="btn btn-cart-red">
                <i className="bi bi-bag-fill"></i> Keranjang {totalUniqueItems > 0 && <span className="cart-badge">{totalUniqueItems}</span>}
              </button>
            </div>
            {/* <h2 className="text-center section-title">Our Merchandise</h2> */}
            {/* <p className="text-center section-subtitle">Tunjukkan semangat studi luar negeri dengan koleksi merchandise eksklusif NIEC.</p> */}
            <div className="merch-divider"></div>

            <div className="row">
              {produk?.map((prod) => {
                const added = inCart(prod.id);
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={prod.id_product}>
                    <div className="merch-product-card">
                      <a href={`/MerchandiseDetail/${prod.code_product}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <div className="product-image-wrapper">
                          <img src={prod?.file_pic} alt={prod?.name_product} />
                        </div>
                        <div className="product-info">
                          <h5 className="product-title">{prod?.name_product}</h5>
                          <p className="product-origin">Made in Indonesia &amp; Kondisi Baru</p>
                          <p className="product-desc">{prod?.description ? prod.description.substring(0, 50) + '...' : 'Eksklusif merchandise untukmu.'}</p>
                          <h5 className="product-price">{FormatRupiah(prod?.price)}</h5>
                        </div>
                      </a>
                      <div className="product-actions">
                        <a href={`/MerchandiseDetail/${prod.code_product}`} className="btn btn-detail">
                          <i className="bi bi-info-circle-fill"></i> Detail
                        </a>
                        <button
                          className={`btn btn-keranjang-outline ${added
                            ? "disabled"
                            : memberExist && prod?.is_with_member === 1
                              ? "disabled"
                              : ""
                            }`}
                          onClick={() => handleAddToCart(prod)}
                        >
                          <i className="bi bi-bag-fill"></i> Keranjang
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Floating Cart Button — only show when cart has items */}
      {totalUniqueItems > 0 && (
        <button
          className="cart-float-btn"
          onClick={() => setShowCart(true)}
          title="Lihat Keranjang"
        >
          <i className="bi bi-bag"></i>
          <span className="cart-float-badge">{totalUniqueItems}</span>
        </button>
      )}

      {/* Cart Popup Sidebar */}
      {showCart && (
        <Cart
          emptyCart={emptyCart}
          onClose={() => setShowCart(false)}
        />
      )}

      <style>{`
        .cart-float-btn {
          position: fixed;
          bottom: 24px;
          left: 24px;
          z-index: 999;
          background: #e51d2a;
          color: white;
          border: none;
          border-radius: 50%;
          width: 60px;
          height: 60px;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(229,29,42,0.35);
          cursor: pointer;
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .cart-float-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 12px 35px rgba(229,29,42,0.4);
        }
        .cart-float-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          background: #111;
          color: white;
          border-radius: 50%;
          width: 22px;
          height: 22px;
          font-size: 12px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </>
  );
};

export default MerchandiseHome;
